import { lazy } from "react";

const AdhocTabsComponentLoadable = lazy(() => import("./AdhocTabsComponent"));
const AdhocReportComponentLoadable = lazy(() => import("./AdhocReport/AdhocReport"));
const AdhocVendorMasterComponentLoadable = lazy(() => import("./Vendor/VendorList"));


export {
    AdhocTabsComponentLoadable,
    AdhocReportComponentLoadable,
    AdhocVendorMasterComponentLoadable
};